
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;
  if ((DL.ctx.page_type || '') !== 'home') return;
  if (w.__djiHomeTracking) return;      
  w.__djiHomeTracking = 1;

  /* ================================================================ */
  
  /* ================================================================ */

  var C = {
    hero:      { component_id: 'home_hero',                placement: 'hero_slide_' },   /* + {n} */
    carousel:  { component_id: 'home_hero',                placement: 'hero_carousel' },
    newsletter:{ component_id: 'home_hero_newsletter',     placement: 'home_hero' },
    seriesNav: { component_id: 'home_series_nav',          placement: 'home_series_carousel' },
    service:   { component_id: 'service_support',          placement: 'home_service_grid' },
    serviceMd: { component_id: 'service_support_modal',    placement: 'home_service_modal' },
    catHero:   { component_id: 'home_category_hero',       placement: 'home_category_hero_' }, /* + {n} */
    grid:      { component_id: 'home_product_grid',        placement: 'home_product_grid_' },  /* + {name} */
    editorial: { component_id: 'home_editorial_category',  placement: 'home_editorial_' },     /* + {name} */
    scroll:    { component_id: 'home_content',             placement: 'home_document' }
  };

  
  var PF = {
    slideshow:  '[data-pf-type="Slideshow"]',
    /* slider_custom 幻灯片没有 data-pf-type（避免命中 PageFly 移动端 background-size:contain），统一用 data-dji-promo-id 识别 */
    slide:      '[data-pf-type="SlideshowSlide"], [data-dji-promo-id]',
    sliderTrack:'.pf-slider',
    sliderPrev: '.pf-slider-prev',
    sliderNext: '.pf-slider-next',
    sliderDots: '.pf-slider-nav > *',
    contentList:'[data-pf-type="ContentList2"]',
    contentItem:'[data-pf-type="ContentListItem"]',
    popupTrig:  '[data-pf-popup-target][data-action="popup-element"]',
    popupOpen:  '.pf-popup-overlay, .pf-popup-dialog',
    productBox: '[data-pf-type="ProductBox"]',
    heading:    '[data-pf-type="Heading2"]',
    newsletter: 'form[action*="/contact"]',
    colLink:    '[data-href*="/collections/"]',
    flex:       '[data-pf-type="FlexBlock"]'
  };

  
  var SERVICE_IDS = [
    [/env[íi]o\s+gratis/i,                'free_shipping'],
    [/devoluci[óo]n/i,                    'returns_30_days'],
    [/12\s*meses|meses\s+para\s+pagar/i,  'installments'],
    [/paga\s+despu[ée]s/i,                'buy_now_pay_later'],
    [/aut[ée]nticos|reacondicionad/i,     'authentic_refurbished'],
    [/asesor[íi]a|expertos/i,             'expert_advice'],
    [/cr[ée]ditos/i,                      'dji_credits'],
    [/env[íi]o\s+r[áa]pido|bodega/i,      'fast_shipping_mx']
  ];

  
  var GRID_NAMES = [
    [/drones?\s+con\s+c[áa]mara/i,    'camera_drones'],
    [/dispositivos\s+port[áa]tiles/i, 'handheld'],
    [/estabilizadores/i,              'stabilizers'],
    [/energ[íi]a\s+port[áa]til/i,     'power']
  ];

  /* ================================================================ */
  
  /* ================================================================ */

  function all(root, sel) { return root ? [].slice.call(root.querySelectorAll(sel)) : []; }
  function txt(el) { return el && el.innerText ? el.innerText.trim().replace(/\s+/g, ' ').slice(0, 80) : ''; }

  function visible(el) {
    if (!el) return false;
    var r, s;
    try { r = el.getBoundingClientRect(); s = w.getComputedStyle(el); } catch (e) { return false; }
    return s.display !== 'none' && s.visibility !== 'hidden' && r.width > 0 && r.height > 0;
  }

  function topOf(el) { return el.getBoundingClientRect().top + (w.pageYOffset || 0); }

  function slug(t) {
    return String(t || '').toLowerCase()
      .replace(/[áàä]/g, 'a').replace(/[éèë]/g, 'e').replace(/[íìï]/g, 'i')
      .replace(/[óòö]/g, 'o').replace(/[úùü]/g, 'u').replace(/ñ/g, 'n')
      .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 40);
  }

  function matchTable(table, text, fallback) {
    for (var i = 0; i < table.length; i++) if (table[i][0].test(text)) return table[i][1];
    return fallback;
  }

  function hrefOf(el) {
    if (!el) return '';
    return el.getAttribute('data-href') || el.getAttribute('href') || '';
  }

  function handleOf(href) {
    var m = String(href || '').match(/\/(?:products|collections)\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function destType(href) {
    if (/\/collections\//.test(href || '')) return 'collection';
    if (/\/products\//.test(href || '')) return 'product';
    if (/\/pages\//.test(href || '')) return 'campaign';
    return undefined;
  }

  function base(componentId, placement, extra) {
    var out = { page_type: 'home', component_id: componentId, placement: placement };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  function productIdOf(box) {
    if (!box) return '';
    var v = box.getAttribute && box.getAttribute('data-product-id');
    if (v) return v;
    var inner = box.querySelector && box.querySelector('[data-product-id]');
    return inner ? inner.getAttribute('data-product-id') : '';
  }

  
  var handlers = [];
  function onClick(fn) { handlers.push(fn); }
  w.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    for (var i = 0; i < handlers.length; i++) {
      try { if (handlers[i](evt, t) === true) return; } catch (e) { DL.log('home click handler error', e); }
    }
  }, true);

  /* ================================================================ */
  
  /* ================================================================ */

  var MODULES = { hero: null, newsletterForms: [], seriesLists: [], serviceTriggers: [], grids: [], catHeroes: [], editorialLinks: [] };

  
  function discover() {
    var m = { hero: null, newsletterForms: [], seriesLists: [], serviceTriggers: [], grids: [], catHeroes: [], editorialLinks: [] };

    
    m.hero = all(d, PF.slideshow).filter(visible)[0] || null;

    
    
    var heroSection = m.hero ? m.hero.closest('section[data-section-id]') : null;
    m.newsletterForms = heroSection
      ? all(heroSection, PF.newsletter).filter(function (f) {
          return visible(f) && !f.closest('footer, #shopify-section-footer, [class*="dji-ft"]');
        })
      : [];

    
    m.seriesLists = all(d, PF.contentList).filter(visible);

    
    m.serviceTriggers = all(d, PF.popupTrig).filter(visible);

    
    var byName = {};
    var cur = null;
    var lastHeadText = '';
    all(d, PF.heading + ',' + PF.productBox + ',video,img').forEach(function (n) {
      var pfType = n.getAttribute('data-pf-type');

      if (pfType === 'Heading2') {
        if (!visible(n)) return;
        if (n.closest(PF.slideshow) || n.closest(PF.contentList)) return;  
        var t = txt(n);
        lastHeadText = t;
        var name = matchTable(GRID_NAMES, t, null);
        if (name) {
          if (!byName[name]) {
            byName[name] = { name: name, title: t, item_list_name: 'Home - ' + t, boxes: [], promoEl: null, promoTxt: null };
            m.grids.push(byName[name]);
          }
          cur = byName[name];
        } else if (cur && !cur.boxes.length && !cur.promoTxt) {
          
          cur.promoEl = cur.promoEl || n.closest(PF.flex) || n;
          cur.promoTxt = t;
        }
        return;
      }

      if (pfType === 'ProductBox') {
        if (!visible(n)) return;
        
        if (!cur) {
          var t2 = lastHeadText || 'Home';
          var nm = slug(t2) || 'grid';
          if (!byName[nm]) {
            byName[nm] = { name: nm, title: t2, item_list_name: 'Home - ' + t2,
                           boxes: [], promoEl: null, promoTxt: null, fallback: true };
            m.grids.push(byName[nm]);
            DL.log('home: 网格标题未命中 GRID_NAMES，已降级为 "' + nm + '"，请核对表格取值', t2);
          }
          cur = byName[nm];
        }
        cur.boxes.push(n);
        return;
      }

      
      if (!cur || cur.boxes.length || cur.promoEl) return;
      if (n.closest(PF.productBox) || n.closest(PF.contentList) || n.closest(PF.slideshow)) return;
      if (!visible(n)) return;
      if (n.getBoundingClientRect().height < 180) return;
      var block = n.closest(PF.flex);
      if (!block || block.querySelector(PF.productBox)) return;
      cur.promoEl = block;
      if (!cur.promoTxt) cur.promoTxt = txt(block).slice(0, 60);
    });

    /* 品类 Hero 优先用显式标记 [data-dji-cat-hero]（桌面/移动端均有）；无标记时才回退到标题/视频推断 */
    var marked = all(d, '[data-dji-cat-hero]').filter(visible);
    if (marked.length) {
      marked.forEach(function (el, i) {
        m.catHeroes.push({
          el: el, n: i + 1, grid: null,
          name: txt(el.querySelector(PF.heading)) || txt(el.querySelector('p strong'))
        });
      });
    } else {
      m.grids.forEach(function (g) {
        if (!g.promoEl) return;
        m.catHeroes.push({ el: g.promoEl, n: m.catHeroes.length + 1, grid: g, name: g.promoTxt });
      });
    }

    
    m.editorialLinks = all(d, PF.colLink).filter(function (el) {
      return visible(el) && !el.closest(PF.contentList) && !el.closest(PF.productBox);
    });

    return m;
  }

  
  function commonAncestor(els) {
    if (!els || !els.length) return null;
    var a = els[0];
    for (var i = 1; i < els.length; i++) {
      var b = els[i];
      while (a && !a.contains(b)) a = a.parentElement;
      if (!a) return els[0].parentElement;
    }
    return a;
  }

  
  function elementIdOfCardClick(t, box) {
    if (t.closest('img, picture, [data-pf-type="ProductMedia3"], [data-pf-type="MediaMain3"]')) return 'product_image';
    if (t.closest('[data-pf-type="ProductTitle"], h1, h2, h3, [class*="title"]')) return 'product_title';
    return 'product_card';
  }

  function gridOf(el) {
    var gs = MODULES.grids;
    for (var i = 0; i < gs.length; i++) {
      for (var j = 0; j < gs[i].boxes.length; j++) {
        var b = gs[i].boxes[j];
        if (b === el || b.contains(el)) return { g: gs[i], box: b, index: j + 1 };
      }
    }
    return null;
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function slotOf(slide) {
    var show = slide.closest(PF.slideshow) || slide.parentElement;
    var i = all(show, PF.slide).indexOf(slide);
    return i > -1 ? i + 1 : 1;
  }

  function promoIdOf(slide, slot) {
    var id = slide && slide.getAttribute('data-dji-promo-id');
    return id ? 'home_hero_' + id : 'home_hero_slot_' + slot;
  }

  function heroInfo(slide) {
    var slot = slotOf(slide);
    var cta = slide.querySelector('[data-href], a[href]');
    var href = hrefOf(cta);
    return {
      slot: slot,
      cta: cta,
      promotion_id: promoIdOf(slide, slot),
      promotion_name: txt(slide.querySelector('h1,h2,h3,' + PF.heading)) || 'home_hero_slot_' + slot,
      creative_slot: 'hero_slide_' + slot,
      creative_name: handleOf(href) || undefined,
      destination_url: href || undefined
    };
  }

  function initHero(hero) {
    if (!hero || hero.__djiHero) return;
    hero.__djiHero = 1;

    all(hero, PF.slide).forEach(function (slide) {
      DL.observe(slide, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
        var p = heroInfo(el);
        if (!DL.once('view_promotion|' + p.promotion_id)) return;
        DL.push('view_promotion', base(C.hero.component_id, 'hero_slide_' + p.slot, {
          promotion_id: p.promotion_id,
          promotion_name: p.promotion_name,
          creative_name: p.creative_name,
          creative_slot: p.creative_slot,
          destination_url: p.destination_url,
          exposure_rule: meta.rule,
          exposure_ratio: meta.ratio_observed
        }));
      });
    });

    onClick(function (evt, t) {
      var slide = t.closest(PF.slide);
      if (!slide || !hero.contains(slide)) return;
      if (t.closest(PF.sliderPrev) || t.closest(PF.sliderNext) || t.closest(PF.sliderDots)) return;
      var p = heroInfo(slide);
      var cta = t.closest('[data-href], a[href]') || p.cta;
      var href = hrefOf(cta) || p.destination_url;
      if (!href) return;
      DL.afterTick(function () {
        var __np = DL.navPush(evt, cta || slide);
        if (!__np) return;
        __np('select_promotion', base(C.hero.component_id, 'hero_slide_' + p.slot, {
          promotion_id: p.promotion_id,
          element_id: 'hero_cta',
          cta_label: txt(cta) || undefined,
          destination_url: href
        }));
      });
      return true;
    });

    initCarousel(hero);
  }

  
  function initCarousel(hero) {
    var track = hero.querySelector(PF.sliderTrack);
    if (!track || track.__djiCarousel) return;
    track.__djiCarousel = 1;

    function count() { return all(hero, PF.slide).length || 1; }
    function currentSlot() {
      var wid = track.clientWidth || 1;
      return Math.min(count(), Math.max(1, Math.round(track.scrollLeft / wid) + 1));
    }

    var last = currentSlot();
    var action = null, actionAt = 0, settle = null;

    

    function markUser(a) { action = a; actionAt = Date.now(); }

    function emit() {
      var now = currentSlot();
      if (now === last) return;
      var from = last;
      last = now;
      
      if (!action || Date.now() - actionAt > 3000) return;   
      var a = action;
      action = null;
      DL.push('carousel_interaction', base(C.carousel.component_id, C.carousel.placement, {
        action: a,
        from_slide: from,
        to_slide: now,
        promotion_id: promoIdOf(all(hero, PF.slide)[now - 1], now)
      }));
    }

    track.addEventListener('scroll', function () {
      if (settle) w.clearTimeout(settle);
      settle = w.setTimeout(emit, 180);      
    }, { passive: true });

    ['touchstart', 'pointerdown', 'mousedown'].forEach(function (ev) {
      track.addEventListener(ev, function () { markUser('swipe'); }, { passive: true });
    });
    track.addEventListener('wheel', function () { markUser('swipe'); }, { passive: true });

    onClick(function (evt, t) {
      if (!hero.contains(t)) return;
      if (t.closest(PF.sliderPrev)) { markUser('previous'); return true; }
      if (t.closest(PF.sliderNext)) { markUser('next'); return true; }
      if (t.closest(PF.sliderDots)) { markUser('dot'); return true; }
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  
  
  var NL_KEY = 'dji_nl_home';

  function initNewsletter(forms) {
    forms.forEach(function (f) {
      if (f.__djiNl) return;
      f.__djiNl = 1;
      f.addEventListener('submit', function () {
        try { w.sessionStorage.setItem(NL_KEY, JSON.stringify({ src: 'home_hero', at: Date.now() })); } catch (e) {}
      }, true);
    });
  }

  function emitNewsletterSuccess() {
    if (!/[?&]customer_posted=true/.test(w.location.search)) return;
    var rec = null;
    try {
      rec = JSON.parse(w.sessionStorage.getItem(NL_KEY) || 'null');
      w.sessionStorage.removeItem(NL_KEY);   
    } catch (e) {}
    if (!rec || rec.src !== 'home_hero') return;       
    if (Date.now() - (rec.at || 0) > 120000) return;
    if (!DL.onceSession('home_newsletter|' + rec.at)) return;

    DL.push('generate_lead', base(C.newsletter.component_id, C.newsletter.placement, {
      form_id: 'home_hero_newsletter',
      lead_type: 'newsletter',
      subscription_source: 'home_hero',
      result: 'success'
      
    }));
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function initSeriesNav(lists) {
    lists.forEach(function (list) {
      if (list.__djiSeries) return;
      list.__djiSeries = 1;

      onClick(function (evt, t) {
        var item = t.closest(PF.contentItem);
        if (!item || !list.contains(item)) return;
        var link = item.matches('[data-href]') ? item : item.querySelector('[data-href], a[href]');
        var href = hrefOf(link) || hrefOf(item);
        if (!href) return;
        var idx = all(list, PF.contentItem).indexOf(item);

        
        var name = txt(item);
        if (!name) {
          var img = item.querySelector('img');
          var alt = img ? (img.getAttribute('alt') || '') : '';
          if (alt && !/\.(jpe?g|png|webp|svg)|__PID:/i.test(alt)) name = alt.trim().slice(0, 40);
        }
        if (!name) name = handleOf(href).replace(/-/g, ' ');

        DL.afterTick(function () {
          var __np = DL.navPush(evt, link || item);
          if (!__np) return;
          __np('category_entry_click', base(C.seriesNav.component_id, C.seriesNav.placement, {
            category_id: handleOf(href) || undefined,
            category_name: name || undefined,
            destination_type: destType(href),
            destination_url: href,
            index: idx > -1 ? idx + 1 : undefined
          }));
        });
        return true;
      });
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  /* 优先返回对话框本身：djimx-service-popups.js 会把 overlay 追加到 body 末尾，若取 overlay，
     后续在对话框内点 Aprende más 时 modal 对不上，service_id/name 会丢失 */
  function popupOpen() {
    var list = all(d, '.pf-popup-dialog').filter(visible);
    if (!list.length) list = all(d, PF.popupOpen).filter(visible);
    return list.length ? list[list.length - 1] : null;
  }

  var openService = null;

  function initService() {
    if (initService.__bound) return;
    initService.__bound = 1;

    onClick(function (evt, t) {
      var trig = t.closest(PF.popupTrig);
      if (!trig) return;
      var label = txt(trig);
      var sid = matchTable(SERVICE_IDS, label, slug(label) || 'service');
      var uuid = trig.getAttribute('data-pf-popup-target') || '';
      var idx = all(d, PF.popupTrig).filter(visible).indexOf(trig);

      
      var before = popupOpen();
      var tries = 0;
      (function wait() {
        var now = popupOpen();
        if (now && now !== before) {
          openService = { id: sid, name: label, modal: now, uuid: uuid };
          DL.push('service_card_open', base(C.service.component_id, C.service.placement, {
            service_id: sid,
            service_name: label || undefined,
            index: idx > -1 ? idx + 1 : undefined,
            modal_id: uuid || undefined
          }));
          return;
        }
        if (++tries < 25) w.setTimeout(wait, 120);
        
      })();
      return true;
    });

    
    onClick(function (evt, t) {
      var modal = t.closest(PF.popupOpen);
      if (!modal) return;
      var link = t.closest('[data-href], a[href]');
      if (!link) return;
      var label = txt(link);
      if (!/aprende|learn|conoce|saber\s+m[áa]s|ver\s+m[áa]s/i.test(label)) return;
      var svc = (openService && openService.modal === modal)
        ? openService
        : { id: matchTable(SERVICE_IDS, txt(modal), 'service'),
            name: txt(modal.querySelector('h1,h2,h3,.pf-popup-body p strong')) };
      var href = hrefOf(link);
      DL.afterTick(function () {
        if (!DL.isInteractive(link)) return;
        DL.push('service_learn_more_click', base(C.serviceMd.component_id, C.serviceMd.placement, {
          service_id: svc.id,
          service_name: svc.name || undefined,
          element_id: 'learn_more',
          destination_url: href || undefined
        }));
      });
      return true;
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function initCategoryHero(heroes) {
    heroes.forEach(function (h) {
      if (h.el.__djiCatHero) return;
      h.el.__djiCatHero = 1;

      var placement = C.catHero.placement + h.n;
      var pid = 'home_category_hero_' + (h.n < 10 ? '0' + h.n : h.n);
      var link = h.el.querySelector('[data-href], a[href]');
      var href = hrefOf(link);
      var pname = h.name || txt(h.el.querySelector('h1,h2,h3,' + PF.heading)) || (h.grid ? h.grid.title : pid);

      DL.observe(h.el, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
        if (!DL.once('view_promotion|' + pid)) return;
        DL.push('view_promotion', base(C.catHero.component_id, placement, {
          promotion_id: pid,
          promotion_name: pname,
          destination_type: destType(href),
          destination_url: href || undefined,
          exposure_rule: meta.rule,
          exposure_ratio: meta.ratio_observed
        }));
      });

      onClick(function (evt, t) {
        if (!h.el.contains(t)) return;
        var cta = t.closest('[data-href], a[href]');
        if (!cta) return;
        var chref = hrefOf(cta);
        if (!chref) return;
        DL.afterTick(function () {
          var __np = DL.navPush(evt, cta);
          if (!__np) return;
          __np('select_promotion', base(C.catHero.component_id, placement, {
            promotion_id: pid,
            element_id: 'hero_cta',
            cta_label: txt(cta) || undefined,
            destination_type: destType(chref),
            destination_url: chref
          }));
        });
        return true;
      });
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  var lastAdd = null;

  /* "$12,999" / "Desde $1,299.00 MXN" → 12999 / 1299 */
  function parsePrice(s) {
    var m = String(s || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return m ? Number(m[0]) : undefined;
  }

  /* 首页卡片没有 __pageflyProducts 数据，item_name / price 从卡片 DOM 读取 */
  function gridItem(box, g, index) {
    var pid = productIdOf(box);
    if (!pid) return null;
    var known = (w.__pageflyProducts || {})[pid];
    return DL.item(pid, {
      index: index,
      item_list_id: 'home_' + g.name,
      item_list_name: g.item_list_name,
      variant_id: box.getAttribute('data-default-variant') || undefined,
      item_name: known ? undefined : (txt(box.querySelector('[data-pf-type="ProductTitle"]')) || undefined),
      price: known ? undefined : parsePrice(txt(box.querySelector('[data-product-price="true"], [data-pf-type="ProductPrice2Item"]')))
    });
  }

  function initGrids(grids) {
    grids.forEach(function (g) {
      
      var host = commonAncestor(g.boxes);
      if (!host || host.__djiGrid) return;
      host.__djiGrid = 1;

      var listId = 'home_' + g.name;
      var placement = C.grid.placement + g.name;

      DL.observe(host, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
        if (!DL.once('view_item_list|' + listId)) return;
        var items = g.boxes.map(function (b, i) { return gridItem(b, g, i + 1); }).filter(Boolean);
        if (!items.length) return;
        DL.push('view_item_list', base(C.grid.component_id, placement, {
          item_list_id: listId,
          item_list_name: g.item_list_name,
          list_batch_index: 1,
          exposure_rule: meta.rule,
          exposure_ratio: meta.ratio_observed,
          items: items
        }));
      });
    });

    if (initGrids.__bound) return;
    initGrids.__bound = 1;

    onClick(function (evt, t) {
      var found = gridOf(t);
      if (!found) return;
      var g = found.g, box = found.box, index = found.index;
      var listId = 'home_' + g.name;
      var placement = C.grid.placement + g.name;

      
      if (t.closest('form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"]')) {
        lastAdd = { at: Date.now(), g: g, listId: listId, placement: placement, index: index };
        return true;
      }

      
      if (t.closest('button, [type="submit"], [type="button"], select, input, label, ' +
                    '[data-pf-type="ProductATC2"], [data-pf-type^="ProductPrice"]')) return;
      var link = t.closest('[data-href], a[href]');
      if (!link && (box.getAttribute('data-href') || box.getAttribute('href'))) link = box;
      var href = hrefOf(link);
      if (!href || !/\/products\//.test(href)) return;
      DL.afterTick(function () {
        var __np = DL.navPush(evt, link || box);
        if (!__np) return;
        var item = gridItem(box, g, index);
        if (!item) return;
        __np('select_item', base(C.grid.component_id, placement, {
          item_list_id: listId,
          item_list_name: g.item_list_name,
          
          element_id: elementIdOfCardClick(t, box),
          index: index,
          destination_url: href,
          items: [item]
        }));
      });
      return true;
    });
  }

  function initAddToCart() {
    if (initAddToCart.__bound) return;
    initAddToCart.__bound = 1;

    DL.onCartSuccess(function (kind, body) {
      if (kind !== 'add') return;
      var ctx = lastAdd && Date.now() - lastAdd.at < 10000 ? lastAdd : null;
      if (!ctx) return;
      lastAdd = null;

      var lines = [];
      if (body && body.items && body.items.length) lines = body.items;
      else if (body && body.id) lines = [body];

      DL.fetchCart().then(function (cart) {
        if (!cart) return;
        var items = DL.itemsFromCartLines(lines, {
          item_list_id: ctx.listId, item_list_name: ctx.g.item_list_name, index: ctx.index
        });
        if (!items.length) return;
        DL.push('add_to_cart', base(C.grid.component_id, ctx.placement, {
          item_list_id: ctx.listId,
          item_list_name: ctx.g.item_list_name,
          element_id: 'quick_add',
          index: ctx.index,
          cart_type: (DL.ctx.cart_type === 'drawer' || DL.ctx.cart_type === 'notification') ? 'drawer' : 'page',
          value: DL.itemsValue(items),
          items: items
        }));
      });
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  
  function editorialIndex(link) {
    var list = MODULES.editorialLinks || [];
    var i = list.indexOf(link);
    return i > -1 ? i + 1 : undefined;
  }

  
  function cleanCatName(str) {
    return String(str || '')
      .replace(/^\s*(m[áa]s\s+informaci[óo]n|learn\s+more|saber\s+m[áa]s)\s*$/i, '')
      .replace(/^\s*(ver|ir a|descubre|explora|conoce)\s+(todos?\s+(los|las)\s+|todas?\s+las\s+)?/i, '')
      .replace(/^\s*(todos?\s+(los|las)|todas?\s+las)\s+/i, '')
      .replace(/\s*[>›»]\s*$/, '')
      .trim();
  }

  function initEditorial() {
    if (initEditorial.__bound) return;
    initEditorial.__bound = 1;

    onClick(function (evt, t) {
      
      var link = t.closest(PF.colLink);
      if (!link) return;
      if (link.closest(PF.contentList)) return;   
      if (link.closest(PF.productBox)) return;    
      if (gridOf(t)) return;

      var href = hrefOf(link);
      var handle = handleOf(href);
      
      
      var elementId = t.closest('svg, [class*="arrow"], [class*="chevron"]') ? 'cta_arrow'
                    : (t.closest('[data-pf-type="Button2"]') || /^\s*(ver|todos|más|mas)/i.test(txt(link))) ? 'cta_text'
                    : 'card';
      
      var nameEl = t.closest('[data-pf-type="Button2"], [data-pf-type^="Paragraph"], h1, h2, h3, h4');
      var name = (nameEl && link.contains(nameEl)) ? cleanCatName(txt(nameEl)) : '';
      if (!name) {
        var btnEl = link.querySelector('[data-pf-type="Button2"]');
        if (btnEl) name = cleanCatName(txt(btnEl));
      }
      if (!name) {
        var ps = all(link, '[data-pf-type^="Paragraph"]');
        if (ps.length) name = cleanCatName(txt(ps[ps.length - 1]));
      }
      if (!name || name.length > 40) name = handle.replace(/-/g, ' ');

      DL.afterTick(function () {
        var __np = DL.navPush(evt, link);
        if (!__np) return;
        __np('category_entry_click', base(
          C.editorial.component_id,
          C.editorial.placement + (handle ? slug(handle) : 'category'), {
            category_id: handle || undefined,
            category_name: name || undefined,
            element_id: elementId,
            destination_url: href,
            index: editorialIndex(link)
          }));
      });
      return true;
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function initScrollDepth() {
    if (initScrollDepth.__bound) return;
    initScrollDepth.__bound = 1;
    DL.scrollDepth({ thresholds: [30, 50, 70, 100], key: 'home_scroll' }, function (pct) {
      DL.push('home_scroll_depth', base(C.scroll.component_id, C.scroll.placement, {
        scroll_percent: pct,
        scroll_method: 'document',
        device_type: DL.deviceType(),
        page_language: DL.ctx.locale || undefined
      }));
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function wire() {
    MODULES = discover();

    if (MODULES.hero) initHero(MODULES.hero);
    initNewsletter(MODULES.newsletterForms);
    initSeriesNav(MODULES.seriesLists);
    initService();
    initCategoryHero(MODULES.catHeroes);
    initGrids(MODULES.grids);
    initAddToCart();
    initEditorial();

    DL.log('home modules', {
      hero: !!MODULES.hero,
      newsletter: MODULES.newsletterForms.length,
      series: MODULES.seriesLists.length,
      service: MODULES.serviceTriggers.length,
      grids: MODULES.grids.map(function (g) { return g.name + '(' + g.boxes.length + ')'; }),
      catHeroes: MODULES.catHeroes.length,
      editorial: MODULES.editorialLinks.length
    });
  }

  function start() {
    if (start.__done) return;
    start.__done = 1;
    wire();
    emitNewsletterSuccess();
    initScrollDepth();

    
    var rescan = null;
    function scheduleRescan() {
      if (rescan) w.clearTimeout(rescan);
      rescan = w.setTimeout(wire, 600);
    }
    try {
      new MutationObserver(scheduleRescan).observe(d.body, { childList: true, subtree: true });
    } catch (e) {}
    w.addEventListener('resize', scheduleRescan, { passive: true });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();

  DL.log('home tracking ready');
})(window, document);
